import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@interacta-shared/data-access-configuration';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { toExternalLinksCategories } from '../models/external-link.deserialize';
import { IExternalLinksCategory } from '../models/external-link.model';

@Injectable({
    providedIn: 'root',
})
export class ExternalLinksService {
    protected http = inject(HttpClient);

    private baseUrlCommunication = `${inject(ENVIRONMENT).apiBasePath.common}/internal/v2/communication/settings`;

    getCategories(): Observable<IExternalLinksCategory[]> {
        return this.http
            .get<{
                items: Array<any>;
            }>(`${this.baseUrlCommunication}/external-links-categories`)
            .pipe(map(({ items }) => toExternalLinksCategories(items)));
    }

    pinLink(externalLinkId: number, pinned: boolean): Observable<void> {
        return this.http.put<void>(
            `${this.baseUrlCommunication}/external-links/${externalLinkId}/pin`,
            null,
            { params: { pinned } },
        );
    }
}
